import React from "react";
import ContentLayout from "../../component/ContentLayout";

const programs = [
  {
    name: "01. Formal Policy: Clear,",
    label: "distributed, and acknowledged.",
  },
  {
    name: "02. Active Monitoring or Enforcement",
    label: "(not surveillance, but meaningful compliance).",
  },
  {
    name: "03. Regular Safety Education & Reinforcement",
    label: "(weekly reminders, real-world examples, policy refreshers).",
  },
  {
    name: "04. Behavior Incentives:",
    label:
      "Like OnMyWay's rewards-based, opt-in system with A1-driven action and communication.",
  },
];

const ZeroTolerancePolicy = () => {
  return (
    <ContentLayout
      className={"items-start rounded-3xl m-2 gap-6 overflow-y-scroll"}
    >
      <p className={"text-3xl font-bold text-primaryText"}>
        Employee Safety Program/Policy
      </p>
      <div
        className={
          "w-full p-6 flex flex-col justify-center items-center gap-4 bg-primary rounded-3xl"
        }
      >
        <div
          className={"w-full text-primaryText text-2xl font-semibold text-left"}
        >
          Distracted Driving Policy Acknowledgment
        </div>
        <div
          className={"w-full text-primaryText text-sm font-medium text-left"}
        >
          I understand that using a mobile device while driving on company time
          or in a company vehicle is strictly prohibited, unless using approved
          hands-free methods. I acknowledge that [Company Name] offers the
          OnMyWay App as a safe, rewards-based tool to help me drive
          distraction-free. I agree to comply with this policy and understand
          that violations may lead to disciplinary action.
        </div>
      </div>
      <div
        className={
          "w-full p-6 flex flex-col justify-start items-center gap-4 bg-primary rounded-3xl"
        }
      >
        <div
          className={"w-full text-primaryText text-2xl font-semibold text-left"}
        >
          When 90% Risk Reduction is Justified
        </div>

        <div
          className={"w-full text-primaryText text-sm font-medium text-left"}
        >
          Per studies by NHTSA, FMCSA, NSC, and major insurance carriers,
          employers can reduce distracted driving crash risk by up to 90% if
          they implement a program with:
        </div>

        <div
          className={
            "w-full text-primaryText text-sm text-left flex-col flex justify-start items-center gap-2"
          }
        >
          {programs.map((program, index) => {
            return (
              <div className={"flex justify-start items-center gap-1 w-full"}>
                <div className={"font-bold"}>{program.name}</div>
                <div className={"font-medium"}>{program.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </ContentLayout>
  );
};

export default ZeroTolerancePolicy;
